import _ from 'lodash';
import { useCallback, useContext } from 'react';
import { ParentContext } from '../ParentContext';
import { storateStatusTypes } from 'global/storage/removeStorage';
import { pageDataValues } from 'global/firestoreData/helpers/pageDataValues';
import { getRefProps } from 'global/firestoreData/helpers/getRefProps';
import { ammendDataWithStaticViewValues } from 'global/common/convert';
import { ref } from 'firebase/storage';
import { onValue } from 'firebase/database';
import { gEnums } from 'global/enums/globalEnums';
import usePageFunctions from './usePageFunctions';

export const usePageData = () => {

  const parentContexts = useContext(ParentContext)
  const { fns } = parentContexts ?? {}
  const { database_fns } = fns

  const page_fns = usePageFunctions()
  const { getGviDeps } = page_fns

  const getPageData = useCallback(({ pageDataProps, callback }) => {
    getThePageData({ pageDataProps, callback, database_fns, getGviDeps })
  }, [])

  return { getPageData };

}


/** 
 * Gets the data for the page
 * @param {object} pageDataProps 
 * @param {object} state 
 * @param {function} callback 
 */
const getThePageData = ({ pageDataProps, callback, database_fns, getGviDeps }) => {

  const {
    // data_state: pageData_state,
    staticViews,
    view,
    viewKey,
    pageData_state,
  } = pageDataProps ?? {}

  const {
    pathName,
    captionProps,
    subCaptionProps,
    caption_page
  } = pageData_state ?? {}// state

  const _dataResultProps = { isPageData: true, view, pageData_state, captionProps, subCaptionProps, caption_page, staticViews }

  if (pathName && viewKey) {
    try {
      getPageData(pageDataProps, callback, database_fns, getGviDeps)
    } catch (error) {
      console.error(error)
      callback(storateStatusTypes({}, _dataResultProps))
    }
  } else {
    callback(pageDataValues({}, _dataResultProps))
  }
}

const getPageData = async (pageDataProps, callback, database_fns, getGviDeps) => {

  const {
    appDataDocuments,
    appUserAccess,
    dataOverrideOn,
    data_state,
    googleData_state,
    isPageData,
    page_state,
    currentSettings_state,
    paps_state,
    page_fns,
    staticViews,
    view,
    viewKey,
  } = pageDataProps

  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { menu: menu_page, viewItems: viewItems_page } = aps_page ?? {}
  const { captionProps, caption: caption_page, subCaptionProps } = menu_page ?? {}

  const { googleDataOn, googleSheetsData } = googleData_state ?? {}

  let viewItem_g;
  let viewItem_page = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}
  if (aps_viewItems && aps_viewItems[view]) { viewItem_g = aps_viewItems[view] }

  const { nonLandingView, pathViews, pathName } = paps_state ?? {}
  const { dataOptions, googleSheets } = aps_global ?? {}

  const { dataLimit, limitDevelopmentData, hideInactiveItems: hideInactiveItems_do } = dataOptions ?? {}
  const { googleSheetsId } = googleSheets ?? {}

  const grpp = {
    stateProps: {
      appUserAccess,
      aps_viewItems,
      dataLimit,
      googleSheetsId,
      hideInactiveItems_do,
      limitDevelopmentData,
      dataOverrideOn,
      nonLandingView,
      pathViews,
      page_fns,
      staticViews,
      getGviDeps,
    },
    actionProps: {
      pathName,
      uivi: view,
      view,
      viewItem_g,
      viewItem: viewItem_page,
      viewKey,
    }

  }

  const refProps = getRefProps(grpp)

  // firestoreRefs
  let { refPath, refPaths, wheres } = refProps
  const { dataConnection } = viewItem_g ?? {}

  const { firebaseType, useGoogleSheetRealtime, documentDependencies } = dataConnection ?? {}
  const trueDbType = useGoogleSheetRealtime ? gEnums.firebaseTypes.realtimeDatabase : firebaseType

  const _dataResultProps = { isPageData, view, viewItem_page, data_state, captionProps, subCaptionProps, caption_page, staticViews }

  const { dataSource } = viewItem_page ?? {}
  const { dataSourceType } = dataSource ?? {}

  const dataCallback = (res) => {
    ammendDataWithStaticViewValues(staticViews, res)
    callback(pageDataValues(res, _dataResultProps))
  }

  switch (dataSourceType) {
    // case gEnums.dataSourceTypes.appComponent:
    // case gEnums.dataSourceTypes.component:
    //   callback(pageDataValues({}, _dataResultProps))
    //   break;
    default:
      switch (view) {
        case 'home':
          callback(pageDataValues({}, _dataResultProps))
          break;

        default:
          switch (trueDbType) {
            case gEnums.firebaseTypes.realtimeDatabase:
              const db = getDatabase();
              const _ref = ref(db, refPath);
              onValue(_ref, (snapshot) => {
                let resultData = snapshot
                callback(pageDataValues(resultData, _dataResultProps))
              })
              break;
            default:
              if (googleDataOn && googleSheetsData && googleSheetsData[view] && googleSheetsData[view][viewKey]) {
                const d = googleSheetsData[view][viewKey]
                callback(d, _dataResultProps)
              } else {
                if (documentDependencies && documentDependencies.length > 0) {
                  callback(pageDataValues(data_state[documentDependencies[0]], _dataResultProps))
                } else {
                  if (appDataDocuments?.[view]?.[viewKey]) {
                    dataCallback({
                      [viewKey]: { ...appDataDocuments[view][viewKey] }
                    })
                  } else {
                    const gdProps = { refPath: refPaths, wheres, callback: dataCallback, opts: { listen: true } }
                    if (database_fns) {
                      database_fns.get_data(gdProps)
                    }
                  }
                }
              }
          }
      }
  }
} 